import { ResourcePage } from "@/components/ResourcePage"
import { z } from "zod"
import { History } from "lucide-react"

const auditSchema = z.object({
  action: z.string().min(1, "Action is required"),
  module: z.string().optional(),
  details: z.string().optional(),
})

const auditColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "action", type: "text", options: { label: "Action" } },
  { key: "module", type: "text", options: { label: "Module" } },
  { key: "user_id", type: "text", options: { label: "User" } },
  { key: "created_at", type: "date", options: { label: "Time" } },
]

export default function AuditPage() {
  return (
    <ResourcePage
      resource="audit"
      title="Audit Logs"
      icon={History}
      columns={auditColumns}
      formFields={[]}
      formSchema={auditSchema}
      emptyMessage="No audit logs available"
      searchPlaceholder="Search audit logs..."
      readonly={true}
    />
  )
}
